<template>
  <div :class="{ [$style['wrapper']]: true }">
    <div :class="$style.search">
      <v-text-field
        v-model="searchText"
        :class="$style.searchinput"
        color="white"
        :label="
          availableScopes.length
            ? $t(`search${!routeScope ? '.term' : `.scope_term.${routeScope}`}`)
            : ''
        "
        flat
        dense
        hide-details
        autocomplete="off"
        :disabled="!availableScopes.length"
        @keyup.enter="setTextSearchQuery"
      >
        <template #append>
          <v-btn
            v-show="searchText"
            color="white"
            icon
            small
            :height="36"
            :width="36"
            :elevation="0"
            class="mr-3"
            :disabled="!availableScopes.length"
            @click="clearTextSearchQuery"
          >
            <v-icon medium>mdi-close-circle</v-icon>
          </v-btn>
          <v-btn
            color="white"
            icon
            small
            :height="36"
            :width="36"
            :elevation="0"
            :disabled="!availableScopes.length"
            @click="setTextSearchQuery"
          >
            <v-icon large>mdi-magnify</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </div>
  </div>
</template>

<script>
import { get, head } from 'lodash-es'
import { mapActions, mapMutations } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'
import SEARCH_ACTIONS from '@/js/plugins/store/modules/search/action-types.js'
import APP_MUTATIONS from '@/js/plugins/store/modules/app/mutation-types.js'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import PermissionMixin from '@/js/mixins/permission-mixin.js'

export default {
  name: 'MobileSearchBar',
  mixins: [PermissionMixin],
  data() {
    // const typeValue = [
    //   FILTER_CONSTANTS.SCOPE.CURRENT,
    //   FILTER_CONSTANTS.SCOPE.OUTLET,
    //   FILTER_CONSTANTS.SCOPE.SERVICE,
    // ]

    return {
      // type: undefined,
      // isFocused: false,
      // typeValue,
      searchText: '',
    }
  },
  computed: {
    searchQuery() {
      const path = `state.${STOREMODULES.SEARCH}.${FILTER_CONSTANTS.TYPE.SEARCH_TEXT}`
      return get(this.$store, path)
    },
    routeScope() {
      return get(this.$route, ['meta', 'scope'])
    },
    availableScopes() {
      return this.getAvailableScopes()
    },
  },
  watch: {
    // routeScope: {
    //   handler() {
    //     if (isUndefined(this.routeScope)) {
    //       return
    //     }
    //     if (this.routeScope !== this.type) {
    //       this.type = this.routeScope
    //       this.setSearchSelection(this.type)
    //     }
    //   },
    //   immediate: true,
    // },
    // type: {
    //   handler() {
    //     if (isUndefined(this.type) || this.routeScope === this.type) {
    //       return
    //     }

    //     this.setSearchSelection(this.type)

    //     if (this.searchQuery !== this.searchText) {
    //       this.setSearchQuery(this.searchText)
    //     }

    //     this.showSearchDialog(true)
    //   },
    //   immediate: true,
    // },
    searchQuery: {
      handler() {
        if (this.searchQuery !== this.searchText) {
          this.searchText = get(this.searchQuery, 0, '')
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(STOREMODULES.APP, {
      setSearchSelection: APP_MUTATIONS.SET_SEARCH_SELECTION,
    }),
    ...mapActions(STOREMODULES.APP, {
      showSearchDialog: APP_ACTIONS.SHOW_SEARCH_DIALOG,
    }),
    ...mapActions(STOREMODULES.SEARCH, {
      setSearchQuery: SEARCH_ACTIONS.SET_SEARCH_QUERY,
    }),
    setTextSearchQuery() {
      this.setSearchQuery(this.searchText)
      if (!this.isSearchRoute) {
        const targetScope = this.routeScope || head(this.availableScopes)
        console.log(`Not a searchroute, route to ${targetScope}`)
        this.$router.push({ name: targetScope })
      }
    },
    clearTextSearchQuery() {
      this.searchText = ''
      this.setSearchQuery(this.searchText)
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  display: flex;

  color: var(--white);

  background-color: var(--primary);
}

// .toggle-bottom-margin {
//   margin-bottom: 2.8rem;
// }

.search {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  :global(.v-application) & :global(.elevation-0) {
    box-shadow: none !important;
  }
}

.searchinput {
  margin-top: 3rem;
  padding: 6px 0 !important;

  :global(.v-toolbar) &:global(.v-input) {
    margin-top: -0.25rem;
  }

  :global(.v-label) {
    color: var(--white) !important;
  }

  :global(.v-input__slot::before),
  :global(.v-input__slot::after) {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      content: '';
    }
    bottom: -0.5rem !important;

    content: none !important;
  }

  :global(.v-input__slot::before) {
    border-color: hsla(0, 0%, 0%, 0.65) !important;
    border-width: 1px !important;
  }

  :global(.v-input__slot:hover::before) {
    border-color: var(--white) !important;
  }

  :global(.v-label) {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      font-size: 1.625rem;
    }
    height: 1.625rem;

    font-size: var(--font-xl);
    // line-height: 1.625rem;
  }

  :global(.v-label--active) {
    top: 7px !important;

    height: 2rem;

    color: var(--white);
    font-size: 1rem;
    line-height: 2rem;
  }

  :global(.v-input__append-inner) {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      margin-right: 0;
    }
    // margin-top: 0.75rem !important;
    margin-right: 0.5rem;
  }

  :global(.v-icon) {
    border-color: var(--black) !important;
  }

  :global(.v-text-field__slot) {
    input {
      @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
        margin-left: 0;
      }
      position: relative;
      top: 0.325rem;

      padding-left: 0.5rem !important;
    }

    :global(.v-label) {
      @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
        left: 4px;
      }
      left: 0.5rem !important;
    }
  }
}

.radios-mobile {
  position: fixed;
  top: 5.78rem;
  left: 0;

  align-items: center;
  width: 100%;
  margin-top: 0 !important;
  padding: 0.5rem;

  background-color: var(--primary);

  :global(.v-radio) {
    margin-bottom: 0 !important;

    :global(.v-label) {
      position: unset !important;

      font-size: 1rem !important;
    }
  }

  :global(.v-input--radio-group__input) {
    flex-direction: row !important;
  }
}

:global(.v-radio).typeinput :global(.v-label) {
  margin-left: 0;
}
</style>
